
<div class="card cardsmall" style="position:relative;">
     <div class="grid grid-nogutter flex-wrap gap-3 p-fluid">
        <div class="col-12 pl-2">
            <p-tabView  [(activeIndex)]="tabIndex" (onChange)="tabOnChange($event)">
                <p-tabPanel header="{{lang.el('Dati preventivo')}}">
                    <div class="grid p-fluid formgrid">
                        <div class="col-3" *ngIf="action!='new'">
                            <label>{{lang.el('Numero ')}}</label>
                            <h4 style="margin:0px;padding:0px">{{prev.id}}</h4>
                        </div>
                        <div class="col-3">
                            <label>{{lang.el('Cliente')}}</label>
                            <p-dropdown appendTo="body" 
                             [filter]="true" 
                             (onChange)="caricaCliente()"
                             [options]="clientiList" [(ngModel)]="prev.account_id"
                             [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-3">
                            <label>{{lang.el('Nuovo cliente')}}</label>
                            <input type="text" pInputText [(ngModel)]="prev.accountName" />
                        </div>
                        <div class="col-3">
                            <label>{{lang.el('Nazione')}}</label>
                            <p-dropdown appendTo="body" 
                            [filter]="true" 
                            optionLabel="name" 
                            optionValue="code" 
                            [options]="countries.countriesList" [(ngModel)]="prev.accountcountry"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        <div class="col-2">
                            <label>{{lang.el('Lingua')}}</label>
                            <p-dropdown appendTo="body" 
                            [options]="langList" [(ngModel)]="prev.lang"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                        
                        <div class="col-6">
                            <label>{{lang.el('Nome opportunità')}}</label>
                            <input type="text" pInputText [(ngModel)]="prev.name" />
                        </div>
                        <div class="col-2">
                            <label>{{lang.el('Data preventivo')}}</label>
                            <p-calendar appendTo="body" dateFormat="dd/mm/yy" [(ngModel)]="prev.exp_closing_date"></p-calendar>
                        </div>
                        <div class="col-2">
                            <label>{{lang.el('Stato preventivo')}}</label>
                            <p-dropdown appendTo="body" [options]="statiprev" [(ngModel)]="prev.status"
                            [style]="{'width':'100%'}"></p-dropdown>
                        </div>
                         <div class="col-1">
                            <label>{{lang.el('Numero')}}</label>
                            <input type="text" pInputText [(ngModel)]="prev.num_opp" />
                        </div>
                       
                        <div class="col-12">
                            <div class="backWhite"  [style]="{'height':'30vh'}">
                                <label>{{lang.el('Note')}}</label>
                                <p-editor [(ngModel)]="prev.note">
                                    <ng-template #header>
                                        <span class="ql-formats">
                                            <select class="ql-size">
                                            <option value="small">{{lang.el('Piccolo')}}</option>
                                            <option selected></option>
                                            <option value="large">{{lang.el('Grande')}}</option>
                                            <option value="huge">{{lang.el('Molto grande')}}</option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-bold" aria-label="Bold"></button>
                                            <button class="ql-italic" aria-label="Italic"></button>
                                            <button class="ql-underline" aria-label="Underline"></button>
                                            <button class="ql-strike" aria-label="Strike"></button>
                                        </span>
                                        <span class="ql-formats">
                                            <select title="Text Color" class="ql-color" defaultValue="Black">
                                            <option value="Red" label="Red"></option>
                                            <option value="rgb(61, 20, 102)" label="rgb(61, 20, 102)"></option>
                                            </select>
                                            <span class="ql-format-separator"></span>
                                            <select title="Background Color" class="ql-background" defaultValue="White">
                                            <option value="Red" label="Red"></option>
                                            <option value="Yellow" label="Yellow"></option>
                                            </select>
                                        </span>
                                        <span class="ql-formats">
                                            <button class="ql-list" value="ordered" >{{lang.el('Lista')}}</button>
                                            <button class="ql-list" value="bullet" >{{lang.el('Elenco')}}</button>
                                            <select title="Text Alignment" class="ql-align" >
                                            <option selected>{{lang.el('Sinistra')}}</option>
                                            <option value="center" label="Center"></option>
                                            <option value="right" label="Right"></option>
                                            <option value="justify" label="Justify"></option>
                                            </select>            
                                        </span> 
                                    </ng-template>
                                    </p-editor>
                            </div>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="{{lang.el('Offerta')}}" *ngIf="action!='new'">
                    <div class="grid">
                        <div class="col-3">
                            <label>{{lang.el('Modello')}}</label>
                            <p-dropdown [options]="doctemplatesList" 
                            [(ngModel)]="prev.doctemplate"
                            name="doctemplate"
                            />
                        </div>
                        
                         <div class="col-6">
                            <label>{{lang.el('Alla cortese attenzione')}}</label>
                            <textarea 
                                rows="3"
                                pInputTextarea 
                                [(ngModel)]="prev.attNe">
                            </textarea>
                        </div>
                        <div class="col-3"></div>
                        <div class="col-6">
                            <label>{{lang.el('Indirizzo cliente')}}</label>
                            <textarea 
                                rows="3"
                                pInputTextarea 
                                [(ngModel)]="prev.indCli">
                            </textarea>
                        </div>
                        
                        <div class="col-6">
                            <label>{{lang.el('Resa')}}</label>
                            <textarea 
                                rows="3"
                                pInputTextarea 
                                [(ngModel)]="prev.resa">
                            </textarea>
                        </div>
                        <div class="col-6">
                            <label>{{lang.el('Tempo di produzione')}}</label>
                            <textarea 
                                rows="3"
                                pInputTextarea 
                                [(ngModel)]="prev.tempoProduzione">
                            </textarea>
                        </div>
                        <div class="col-6">
                            <label>{{lang.el('Validità offerta')}}</label>
                            <textarea 
                                rows="3"
                                pInputTextarea 
                                [(ngModel)]="prev.validitaOfferta">
                            </textarea>
                        </div>
                        <div class="col-6">
                            <label>{{lang.el('Condizioni pagamento')}}</label>
                            <textarea 
                                rows="3"
                                pInputTextarea 
                                [(ngModel)]="prev.condizioniPagamento">
                            </textarea>
                        </div>
                    </div>
                    <div class="col-2">          
                            <button  pButton label="{{lang.el('Crea offerta')}}"
                                class="p-button-outlined mb-2" icon="pi pi-file-word" (click)="creaOfferta2(false)">
                            </button>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="{{lang.el('Documenti')}}"  *ngIf="action!='new'">
                    <p-table #docstable 
                        *ngIf="!loadingDocs"
                        [value]="docsList" 
                        [rowHover]="true" 
                        styleClass="p-datatable-gridlines" 
                        [paginator]="false" 
                        [loading]="loadingDocs" 
                        responsiveLayout="scroll">
                        <ng-template pTemplate="caption">
                            <div class="grid">
                                <div class="col-2">
                                    <button type="button"
                                        pButton pRipple
                                        icon="pi pi-cog"
                                        (click)="caricaDocDialog()"
                                        class="p-button-info"
                                        label="{{lang.el('Carica documento')}}">
                                    </button>  
                                </div>    
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th>{{lang.el('Download')}}</th>
                                <th pSortableColumn="tipo">{{lang.el('Tipo documento')}}<p-sortIcon field="tipo" /></th>
                                <th pSortableColumn="descrizione">{{lang.el('Oggetto')}}<p-sortIcon field="descrizione" /></th>
                                <th pSortableColumn="last_update">{{lang.el('Data documento')}}<p-sortIcon field="last_update" /></th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-record  let-rowIndex="rowIndex">
                            <tr>
                                <td>
                                    <button pButton pRipple icon="pi pi-eye" 
                                        class="p-button-rounded p-button-text" (click)="downloadDoc(record)">
                                    </button>
                                </td>
                                <td>{{ record.tipo}}</td>
                                <td>{{ record.descrizione}}</td>
                                <td>{{ record.last_update | date: 'dd/MM/yyyy' }}</td>
                                <td>
                                    <button pButton pRipple icon="pi pi-trash" 
                                        class="p-button-rounded p-button-text" (click)="eliminaDoc(record,rowIndex)">
                                    </button>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                    
                </p-tabPanel>
                <p-tabPanel header="{{lang.el('Celle preventivo')}}" *ngIf="action!='new'">
                    <p-table #maintable 
                        [value]="prev.celle" 
                        [columns]="cols"
                        dataKey="id" 
                        [rowHover]="true" 
                        styleClass="p-datatable-gridlines" 
                        [paginator]="false" 
                        responsiveLayout="scroll">
				        <ng-template pTemplate="caption">
                            <div class="grid">
                                <div class="col-2">
                                    <button *ngIf="isInvioBCEnabled()"
                                    pButton label="{{lang.el('Invia a BC')}}"
                                        class="p-button-outlined mb-2" icon="pi pi-send" (click)="invioBC()"></button>

                                </div>
                                <div *ngIf="false" class="col-2">
                                    <button pButton label="Stampa lingue"
                                    class="p-button-outlined ml-2 mb-2" icon="pi pi-plus" (click)="lang.printNotFound()"></button>
                    
                                </div>
                                <div class="col-2">
                                    <button pButton 
                                    label="{{lang.el('Nuovo disegno')}}" style="margin-left:10px;"
                                        class="p-button-outlined ml-2 mb-2" icon="pi pi-plus" (click)="nuovoDisegno()"></button>

                                </div>
                                   
                                <div class="col-2">
                                    <button pButton *ngIf="(globalService.getUser().role=='RESPONSABILE' || globalService.getUser().role=='AMMINISTRATORE' ) && globalService.getUser().organization=='MISA'"
                                    label="{{lang.el('Nuovo disegno Electrolux')}}" style="margin-left:10px;"
                                        class="p-button-outlined ml-2 mb-2" icon="pi pi-plus" (click)="nuovoDisegno('electrolux')"></button>
                                   
                                </div>
                                 
                            </div>
                        </ng-template>
                        <ng-template  pTemplate="header" let-columns>
                            <tr>
                                <th *ngFor="let col of columns" 
                                [pSortableColumn]="col.field" 
                                [pSortableColumnDisabled]="col.pSortableColumnDisabled" 
                                [style]="col.style">
                                    {{ lang.el(col.header) }} <p-sortIcon *ngIf="!col.pSortableColumnDisabled" field="col.field" />
                                </th>
                            </tr>
                        </ng-template>
                        
                        <ng-template pTemplate="body" 
                        let-rowData 
                        let-editing="editing" 
                        let-columns="columns"  
                        let-rowIndex="rowIndex">
                            <tr  [pEditableRow]="rowData">
                                <td pEditableColumn *ngFor="let col of columns">
                                    <div *ngIf="col.type=='edit'" class="flex">
                                        <button pButton pRipple icon="pi pi-pencil" 
                                        class="p-button-rounded p-button-text" (click)="editCella(rowData)"></button>
                                    </div>
                                    
                                    <div *ngIf="col.type=='editsconto'" [style]="col.style">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-inputNumber 
                                                mode="decimal"
                                                [locale]="locale"
                                                [maxFractionDigits]="2"
                                                (onBlur)="salvaSconto(rowData)"
                                                [(ngModel)]="rowData[col.field]"></p-inputNumber>
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{rowData[col.field]}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                    <div *ngIf="col.type=='editstato'  && rowData.status!='INVIATA BC'" [style]="col.style">
                                        <p-cellEditor>
                                            <ng-template pTemplate="input">
                                                <p-dropdown [options]="statusCellaOptions" 
                                                [(ngModel)]="rowData[col.field]"
                                                name="language"
                                                appendTo="body"
                                                [style]="{'width':'100%'}"
                                                (onChange)="salvaSconto(rowData)"
                                                />    
                                            </ng-template>
                                            <ng-template pTemplate="output">
                                                {{lang.el(rowData[col.field])}}
                                            </ng-template>
                                        </p-cellEditor>
                                    </div>
                                    <div *ngIf="col.type=='editstato'  && rowData.status=='INVIATA BC'" [style]="col.style">
                                            {{lang.el(rowData[col.field])}}
                                    </div>

                                    <div *ngIf="col.type=='field'" [style]="col.style">
                                        {{ rowData[col.field] }}
                                    </div>
                                    <div *ngIf="col.type=='currency'" [style]="col.style">
                                        {{rowData[col.field] |currency:'EUR':'symbol' }}
                                    </div>
                            
                                    <div *ngIf="col.type=='date'" [style]="col.style">
                                        {{ rowData[col.field] | date: 'dd/MM/yyyy' }}
                                    </div>
                            
                                    <div *ngIf="col.type=='check'" class="text-center">
                                        <i class="pi" [ngClass]="{'true-icon pi-check-circle text-green-500': rowData[col.field], 'false-icon pi-times-circle text-pink-500': !rowData[col.field]}"></i>
                                    </div>

                                    <div *ngIf="col.type=='duplica'" class="flex">
                                        <button pButton pRipple icon="pi pi-copy" 
                                        class="p-button-rounded p-button-text"  title="{{lang.el('Duplica')}}"  (click)="duplicaCella(rowData)"></button>
                                    </div>
                                    <div *ngIf="col.type=='delete' && rowData.status!='INVIATA BC'" class="flex">
                                        <button pButton pRipple icon="pi pi-trash" 
                                        class="p-button-round   ed p-button-text" title="{{lang.el('Cancella')}}" (click)="deleteCella(rowData)"></button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr>
                                <td></td>
                                <td></td>
                                <td><b>{{ lang.el('Prezzo totale listino') }}</b></td>
                                <td><b>{{ getPrezzoTotaleListino() | currency: 'EUR' }}</b></td>
                                <td><b>{{ lang.el('Prezzo totale netto') }}</b></td>
                                <td><b>{{ getPrezzoTotale() | currency: 'EUR' }}</b></td>
                                <td></td>
                            </tr>
                            
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="8">{{lang.el('Nessuna configurazione presente')}}</td>
                            </tr>
                        </ng-template>  
    		        </p-table>
                </p-tabPanel>
               
                <p-tabPanel 
                *ngIf="showEditor"
                header="{{lang.el('Editor grafico')}} {{configurazioneCelle.description}}" 
                >
                    <div class="grid" >
                     
                        <div class="col-12 pl-0">
                            <app-model-design #modeldesign
                            [(cC)]="configurazioneCelle"
                            (messageEvent)="messageEvent($event)" 
                            [opzioniList]="opzioniList"
                            [prev]="prev"
                             ></app-model-design>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel 
                header="{{lang.el('Disegno configurazione')}}: {{configurazioneCelle.description}}" *ngIf="showCella">
                    <div class="grid">
                        <div class="col-12">
                            <app-model-viewer  [configurazioneCelle]="configurazioneCelle" ></app-model-viewer>
                        </div>
                    </div>
                </p-tabPanel>
                <p-tabPanel header="{{lang.el('Distinta configurazione')}}: {{configurazioneCelle.description}}" *ngIf="showCella">

                
                    <p-table  #dt

                    [scrollable]="true" 
                    scrollHeight="400px" 
                    rowGroupMode="subheader" 
                    groupRowsBy="codicePadre" 
                    [value]="modelService.distintaData" 
                    csvSeparator=";"
                    [columns]="colsDistinta"
                    [globalFilterFields]="['codicePadre', 'art_comp', 'des_comp']"
                    [tableStyle]="{ 'min-width': '50rem' }">
                        <ng-template pTemplate="caption">
                            <div class="flex justify-content-between">
                                <button type="button"
                                            pButton pRipple
                                            icon="pi pi-file-excel"
                                            (click)="exportExcel()"
                                            class="p-button-outlined p-button-success"
                                            class="p-button-success "
                                            pTooltip="XLSX"
                                            label="Export XLSX"
                                            tooltipPosition="bottom">
                                </button>
                                <button type="button"
                                            pButton pRipple
                                            icon="pi pi-file-pdf"
                                            style="margin-left:20px;"
                                            (click)="exportPDF()"
                                            class="p-button-outlined p-button-success"
                                            class="p-button-success "
                                            pTooltip="Export PDF"
                                            label="Export PDF"
                                            tooltipPosition="bottom">
                                </button>
                                <button type="button"
                                            pButton pRipple
                                            style="margin-left:20px;"
                                            icon="pi pi-file-export"
                                            (click)="exportCSVCustom(dt)"
                                            class="p-button-outlined p-button-success"
                                            class="p-button-success "
                                            pTooltip="CSV"
                                            label="Export CSV"
                                            tooltipPosition="bottom">
                                </button>
                             
                                 <button 
                                    pButton pRipple class="p-button-secondary" 
                                    style="margin-left:20px;"
                                    (click)="openDialogComp()"
                                    label="{{lang.el('Aggiungi componente')}}" icon="pi pi-fw pi-check">
                                </button>  

                                <button 
                                    pButton pRipple class="p-button-secondary" 
                                    style="margin-left:20px;"
                                    (click)="openDialogRiga()"
                                    label="{{lang.el('Aggiungi riga')}}" icon="pi pi-fw pi-check">
                                </button> 
                                
                                <button 
                                    pButton pRipple class="p-button-secondary" 
                                    style="margin-left:20px;"
                                    (click)="resetDistinta()"
                                    label="{{lang.el('Reset distinta')}}" icon="pi pi-fw pi-check">
                                </button>  

                                <span class="p-input-icon-left ml-auto col-2">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" (input)="dt.filterGlobal($any($event.target).value, 'contains')" placeholder="Search keyword" />
                                </span>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="art_comp">{{lang.el('Codice')}}<p-sortIcon field="art_comp" /></th>
                                <th pSortableColumn="des_comp">{{lang.el('Descrizione')}}<p-sortIcon field="des_comp" /></th>
                                <th style="text-align:right" pSortableColumn="pzu_comp_uni">{{lang.el('Prezzo unitario')}}<p-sortIcon field="pzu_comp_uni" /></th>
                                <th *ngIf="this.globalService.getUser().organization=='MISA' && globalService.getUser().role=='AMMINISTRATORE'" style="text-align:right" pSortableColumn="pzu_costo">{{lang.el('Costo')}}<p-sortIcon field="pzu_costo" /></th>
                                <th style="text-align:right" pSortableColumn="quantity">{{lang.el('Quantità')}}<p-sortIcon field="quantity" /></th>
                                <th style="text-align:right" pSortableColumn="pzu_comp">{{lang.el('Prezzo')}}<p-sortIcon field="pzu_comp" /></th>
                            
                                <th pSortableColumn="new">{{lang.el('Componente aggiunto')}}<p-sortIcon field="new" /></th>
                                <th></th>
                            </tr>
                        </ng-template>
                      <ng-template pTemplate="groupheader" let-record>
                            <tr pRowGroupHeader>
                                <td colspan="9">
                                    <span class="font-bold ml-2">{{record.codicePadre}}</span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="groupfooter" let-record>
                            <tr>
                                <td colspan="5" class="text-right font-bold">
                                   {{ lang.el('Prezzo totale')+' '+record.codicePadre }}: {{calcTotalGroup(record.codicePadre) | currency : 'EUR' }}
                                </td>
                                <td colspan="4"></td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" 
                            let-editing="editing" 
                            let-record>
                             <tr  [pEditableRow]="record"  [ngStyle]="{'color': record.active ? 'inherit' : 'red'}">
                                <td>{{ record.art_comp }}</td>
                                <td style="width:40%;">{{ record.des_comp }}</td>
                                <td style="text-align:right">{{ record.pzu_comp_uni | currency: 'EUR' }}</td>
                                <td 
                                *ngIf="this.globalService.getUser().organization=='MISA' && globalService.getUser().role=='AMMINISTRATORE'" 
                                style="text-align:right" >{{ record.pzu_costo | currency: 'EUR' }}</td>
                         
                                <td pEditableColumn style="text-align:right">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <p-inputNumber 
                                            (onBlur)="refreshDistinta(record)"
                                            [(ngModel)]="record.quantity"></p-inputNumber>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            {{record.quantity}}
                                        </ng-template>
                                    </p-cellEditor>
                                </td>
                                <td style="text-align:right">{{ record.pzu_comp | currency: 'EUR' }}</td>
                              
                                <td *ngIf="record.new && record.new=='x'" style="text-align:center;width:120px;">
                                    <i class="pi pi-check"></i>
                                </td>
                                <td *ngIf="!record.new"> </td>
                                <td pEditableColumn >
                                    <p-cellEditor >
                                        <ng-template pTemplate="input">
                                            <p-checkbox name="record.active"  
                                            (onChange)="changeActive(record)"
                                            [(ngModel)]="record.active" styleClass="mr-2" [binary]="true"></p-checkbox>
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <div class="text-center">
                                                <i class="pi" [ngClass]="{'true-icon pi-check-circle text-green-500': record.active, 'false-icon pi-times-circle text-pink-500': !record.active}"></i>
                                            </div>
                                        </ng-template>
                                    </p-cellEditor>
                                  
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="footer">
                            <tr>
                                <td></td>
                                <td></td>
                                <td><b>{{ lang.el('Prezzo totale') }}</b></td>
                                <td></td>
                                <td style="text-align:right;width:150px;"><b>{{ configurazioneCelle.prezzolordo | currency: 'EUR' }}</b></td>
                                <td></td>
                                <td></td>
                                <td></td>
                               
                            </tr>
                            
                        </ng-template>
                    </p-table>
                </p-tabPanel>
                
            </p-tabView>
        </div>
    </div>
</div>
<div class="grid">
    <div class="col-12">
        <div class="flex-1 w-full lg:w-3 xl:w-4 flex flex-column row-gap-3">
            <div class="flex flex-column sm:flex-row gap-3 py-2">
                <button
                pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="annulla()"
                label="{{lang.el('Annulla')}}"></button>
                <button 
                pButton pRipple class="p-button-primary flex-1 border-round" 
                (click)="save()"
                [disabled]="tabIndex!=0 && tabIndex!=1 && tabIndex!=3"
                label="{{lang.el('Salva preventivo')}}" icon="pi pi-fw pi-check"></button>  
            </div>
        </div>
    </div>
</div>

<p-dialog header="{{lang.el('Aggiungi componente')}}" [(visible)]="showDialogAddComp" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12">
            <label>{{lang.el('Gruppo distinta')}}</label>
            <p-dropdown appendTo="body" 
                [options]="gruppoDistintaList" 
                [(ngModel)]="gruppoDistinta"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
        <div class="col-4">
             <label>{{lang.el('Descrizione componente')}}</label>
            <input pInputText [(ngModel)]="compSearchDesc" class="flex-auto" autocomplete="off" />    
        </div>
        <div class="col-4">
             <label>{{lang.el('Codice componente')}}</label>
            <input pInputText [(ngModel)]="compSearchCode" class="flex-auto" autocomplete="off" />    
        </div>
        <div class="col-3">
            <button 
            pButton pRipple class="p-button-secondary flex-1 border-round" 
            (click)="searchComp()"
            [disabled]="compSearchCode=='' && compSearchDesc==''"
            label="{{lang.el('Ricerca')}}" icon="pi pi-fw pi-check">
            </button>  
        </div>

        <div class="col-12">
            <label>{{lang.el('Componente')}}</label>
            <p-dropdown appendTo="body" 
                [options]="componentList" 
                [loading]="loadingComponentList"
                optionLabel="des_comp" 
                optionValue="art_comp" 
                [(ngModel)]="compToAdd"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
        <div class="col-2">
            <label>{{lang.el('Quantità')}}</label>
             <p-inputNumber 
            [(ngModel)]="qtyToAdd"></p-inputNumber>
        </div>
    </div>
  <p-footer>
    <button pButton 
    label="{{lang.el('Aggiungi componente')}}" class="p-button-success" (click)="addCompToDistinta()"></button>

  </p-footer>
</p-dialog>

               

<p-dialog header="{{lang.el('Aggiungi riga')}}" [(visible)]="showDialogAddRiga" 
[modal]="true" 
[style]="{ width: '20vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid p-fluid formgrid">
        <div class="col-12">
            <label>{{lang.el('Gruppo distinta')}}</label>
            <p-dropdown appendTo="body" 
                [options]="gruppoDistintaList" 
                [(ngModel)]="gruppoDistinta"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
        <div class="col-12">
             <label>{{lang.el('Codice')}}</label>
            <input pInputText [(ngModel)]="riga.art_comp" class="flex-auto" autocomplete="off" />    
        </div>
        <div class="col-12">
             <label>{{lang.el('Descrizione')}}</label>
            <input pInputText [(ngModel)]="riga.des_comp" class="flex-auto" autocomplete="off" />    
        </div>
        <div class="col-12">
             <label>{{lang.el('Prezzo unitario')}}</label>
            <p-inputNumber  pInputText 
                mode="currency" 
                currency="EUR" 
                [(ngModel)]="riga.pzu_comp_uni" class="flex-auto" autocomplete="off" />    
        </div>
          <div class="col-12">
             <label>{{lang.el('Quantità')}}</label>
            <p-inputNumber  pInputText [(ngModel)]="riga.quantity" class="flex-auto" autocomplete="off" />    
        </div>
    </div>
  <p-footer>
    <button pButton 
    label="{{lang.el('Aggiungi riga')}}" 
    [disabled]="!riga.quantity || riga.quantity<=0 || !riga.pzu_comp_uni || riga.pzu_comp_uni<=0"
    class="p-button-success" 
    (click)="addRigaToDistinta()"></button>

  </p-footer>
</p-dialog>


<p-dialog header="{{lang.el('Stampa tavole')}}" [(visible)]="showDialogPrint" 
[modal]="true" 
[style]="{ width: '30vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12">
            <label>{{lang.el('Stampa')}}</label>
            <p-dropdown appendTo="body" 
                [options]="tipodistampaList" [(ngModel)]="tipoStampa"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
        <div class="col-12">
            <label>{{lang.el('Formato')}}</label>
            <p-dropdown appendTo="body" 
                [options]="formatostampaList" [(ngModel)]="formatoStampa"
                [style]="{'width':'100%'}">
            </p-dropdown>
        </div>
    </div>
  <p-footer>
    <button pButton 
    label="{{lang.el('Stampa tavole')}}" class="p-button-success" (click)="printTavole(false)"></button>

  </p-footer>
</p-dialog>



<p-dialog header="{{lang.el('Opzioni cella')}}" [(visible)]="showOpzioni" *ngIf="selectedCella && selectedCella.opzioni"
[modal]="true" 
[breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" 
[style]="{ width: '50vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">

        <div class="col-10">
            <label>{{lang.el('Descrizione')}}</label>
        </div>
      
        <div class="col-2">
            <label>{{lang.el('Quantità')}}</label>
        </div>
    </div>
    <div class="grid pl-4 pr-4" *ngFor="let opt of selectedCella.opzioni">
        <div class="col-10">
            {{lang.el(opt.descrizione_opzione_cella)}}
        </div>

      

        <div class="col-2">
            <p-dropdown appendTo="body" 
            [options]="numopzioniList" [(ngModel)]="opt.qty"
            [style]="{'width':'100%'}"></p-dropdown>
        </div>
    </div>
  <p-footer>
    <button pButton 
  
    label="{{lang.el('Aggiorna distinta')}}" class="p-button-success" (click)="aggiornaDistinta()"></button>
  </p-footer>
</p-dialog>



<p-dialog header="{{lang.el('Carica documento')}}" [(visible)]="showDocs" 
[modal]="true" 
[style]="{ width: '40vw', height: '60vh' }" 
[draggable]="false" [resizable]="false">
    <div class="grid p-fluid formgrid">          
        <div class="col-12">
            <label>{{lang.el('Descrizione')}}</label>
            <input pInputText [(ngModel)]="newDoc.descrizione" class="flex-auto" autocomplete="off" />
        </div>
        <div class="col-12">
            <label>{{lang.el('Tipo documento')}}</label>
            <p-dropdown [options]="tipoDocOptions" 
            appendTo="body" [(ngModel)]="newDoc.tipo" 
            [style]="{'width':'100%'}"></p-dropdown>
        </div>
        <div class="col-12">
            <p-fileUpload 
                name="docs[]" 
                [url]="urlapi" 
                (onUpload)="onUpload($event)" 
                (onBeforeSend)="onBeforeSend($event)" 
                [multiple]="false" 
                maxFileSize="10000000"> 
            </p-fileUpload>
        </div>
    </div>
  <p-footer>
     <button 
        pButton pRipple class="p-button-primary flex-1 border-round" 
        (click)="salvaDoc()"
        [disabled]="!newDoc.id || newDoc.id==0"
        label="{{lang.el('Conferma')}}" icon="pi pi-fw pi-check"></button>
  </p-footer>
</p-dialog>


<p-dialog header="{{lang.el('Attenzione')}}" [(visible)]="showDialogEleNonTrovati" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12" >
            <label> {{lang.el('Elementi non trovati nella configurazione:')}}</label>
        </div>
        <div class="col-12" style="font-weight:700;">
             {{modelService.message}}
        </div>
    </div>
  <p-footer>
    <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="showDialogEleNonTrovati=false"
                label="{{lang.el('Chiudi')}}"></button>
  </p-footer>
</p-dialog>

<p-dialog header="{{lang.el('Attenzione')}}" [(visible)]="showError" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid">
        <div class="col-12" >
            <label> {{lang.el('Sono presenti errori nella configurazione:')}}</label>
        </div>
        <div class="col-12 pb-0" *ngFor="let err of errorMessage">
             {{err}}
        </div>
    </div>
  <p-footer>
    <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="showError=false"
                label="{{lang.el('Chiudi')}}"></button>
  </p-footer>
</p-dialog>



<p-confirmDialog  [acceptButtonStyleClass]="'p-button-text'"
[rejectButtonStyleClass]="'p-button-text p-button-danger'"></p-confirmDialog>

<p-toast></p-toast>
